import editorReducer, {
  setInitialEditor,
  addEmptyAchievement,
  addEmptyProcesses,
  addEmptyChoice,
  addEmptyChoiceVisibleConditionItems,
  addEmptyChoiceRequiredItems,
  addEmptyChoiceResult,
  addEmptyChoiceResultStoreProperty,
  addEmptyChoiceResultDestroyStoreProperty,
  addEmptyResultProbabilityCondition,
  addEmptyResultRequiredItemsCondition,
  setAchievementModalStateByType,
  setAchievementId,
  setAchievementChipState,
  setAllAchievementText,
  setAchievementTextByType,
  setSelectedProcessId,
  setIsUsingPageTabPress,
  setProcess,
  setProcessText,
  setChoiceText,
  setChoiceResult,
  setChoiceResultStoreProperty,
  setChoiceResultDestroyProperty,
  setChoiceVisibleConditionItems,
  setChoiceRequired,
  setRequiredSponsorCookie,
  setResultProbabilityCondition,
  setResultRequiredItemsCondition,
  setChangeStatus,
  setIsEventFinish,
  updateChoices,
  updateChoiceResults,
  updateChoicePropertyChipState,
  updateResultPropertyChipState,
  duplicateAchievement,
  duplicateProcess,
  moveProcess,
  duplicateChoice,
  duplicateChoiceResult,
  deleteAllEmptyPropertyAchievement,
  deleteAchievementId,
  deleteAchievementIds,
  deleteAchievement,
  deleteProcess,
  deleteAllChoices,
  deleteChoice,
  deleteChoiceResult,
  deleteChoiceResultProperty,
  deleteChoiceProperty,
  deleteChoiceResultPropertyChipState,
  deleteResultPropertyChipState,
  setInitialProcess,
  addEmptyChoiceRequiredSponsorCookieItems,
  setIfs,
  addPageBetweenProcesses,
  addEmptyProcessesHighLight,
  resetHilightProcess,
  addMoveProcessHighLight,
} from './Reducer';

import {
  useEditor,
  usePageElements,
  useItemNames,
  useItemNamesByType,
  useProcessIdsByItemName,
  useProcessKeysByAchievementId,
  useProcessIdsByValidationPassed,
  usePropertyTextByType,
  useHilightProcess,
  useSelectedProcessId,
} from './Selector';

import { EDITOR_REDUCER_NAME } from './Constants';

export {
  setInitialEditor,
  addEmptyAchievement,
  addEmptyProcesses,
  addEmptyChoice,
  addEmptyChoiceVisibleConditionItems,
  addEmptyChoiceRequiredItems,
  addEmptyChoiceRequiredSponsorCookieItems,
  addEmptyChoiceResult,
  addEmptyChoiceResultStoreProperty,
  addEmptyChoiceResultDestroyStoreProperty,
  addEmptyResultProbabilityCondition,
  addEmptyResultRequiredItemsCondition,
  setAchievementModalStateByType,
  setAchievementId,
  setAchievementChipState,
  setAllAchievementText,
  setAchievementTextByType,
  setSelectedProcessId,
  setIsUsingPageTabPress,
  setProcess,
  setProcessText,
  setChoiceText,
  setChoiceResult,
  setChoiceResultStoreProperty,
  setChoiceResultDestroyProperty,
  setChoiceVisibleConditionItems,
  setChoiceRequired,
  setRequiredSponsorCookie,
  setResultProbabilityCondition,
  setResultRequiredItemsCondition,
  setChangeStatus,
  setIsEventFinish,
  updateChoices,
  updateChoiceResults,
  updateChoicePropertyChipState,
  updateResultPropertyChipState,
  duplicateAchievement,
  duplicateProcess,
  moveProcess,
  duplicateChoice,
  duplicateChoiceResult,
  deleteAllEmptyPropertyAchievement,
  deleteAchievementId,
  deleteAchievementIds,
  deleteAchievement,
  deleteProcess,
  deleteAllChoices,
  deleteChoice,
  deleteChoiceResult,
  deleteChoiceResultProperty,
  deleteChoiceProperty,
  deleteChoiceResultPropertyChipState,
  deleteResultPropertyChipState,
  setInitialProcess,
  setIfs,
  addPageBetweenProcesses,
  addEmptyProcessesHighLight,
  resetHilightProcess,
  addMoveProcessHighLight,
  useHilightProcess,
  useSelectedProcessId,
  useEditor,
  usePageElements,
  useItemNames,
  useItemNamesByType,
  useProcessIdsByItemName,
  useProcessKeysByAchievementId,
  useProcessIdsByValidationPassed,
  usePropertyTextByType,
  EDITOR_REDUCER_NAME,
};

export default editorReducer;
